// ElevenLabs Eleven v4 voices available through Fal.
// https://fal.ai/models/elevenlabs/tts/eleven-v4/api
export const READ_ALOUD_VOICES = [
  // Keep the original saved values so existing preferences retain their voice.
  { value: 'female', gender: 'female', providerVoice: 'Rachel' },
  { value: 'sarah', gender: 'female', providerVoice: 'Sarah' },
  { value: 'laura', gender: 'female', providerVoice: 'Laura' },
  { value: 'male', gender: 'male', providerVoice: 'Roger' },
  { value: 'george', gender: 'male', providerVoice: 'George' },
  { value: 'brian', gender: 'male', providerVoice: 'Brian' },
];

export const DEFAULT_READ_ALOUD_VOICE = 'female';

export const normalizeReadAloudVoice = (value) => (
  READ_ALOUD_VOICES.some(voice => voice.value === value) ? value : DEFAULT_READ_ALOUD_VOICE
);

export const getReadAloudVoice = (value) => (
  READ_ALOUD_VOICES.find(voice => voice.value === normalizeReadAloudVoice(value))
);

export const getReadAloudProviderVoice = (value) => (
  getReadAloudVoice(value).providerVoice
);
